export default __webpack_public_path__ + "static/media/cs1.7e2b109c.png";